import React from 'react';
import { Card, CardContent, Typography, Box, Collapse } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

// Credentials the demo department is seeded with (scripts/demo_seed):
// the demo admin, and the infoscreens and phone scanners, which log in through
// the same form with their name in the staff field and their code as password.
export const DEMO_DEPARTMENT = 'orbit-demo';
const DEMO_USER = { name: 'demo', password: 'demo1234' };
// Every other seeded staff member has this PIN (e.g. on the scanner2 staff picker)
const DEMO_STAFF_PIN = '1234';
const DEMO_INFOSCREEN = { name: 'info1 / info2 / info3', code: '12345678' };
// scanner1 books as the scanner; scanner2 asks for a staff PIN first
const DEMO_SCANNER = { name: 'scanner1 / scanner2', code: '12345678' };

function Line({ label, value }) {
  return (
    <Typography variant="body2" sx={{ mb: 0.5 }}>
      {label}: <strong>{value}</strong>
    </Typography>
  );
}

/**
 * Shown beside the login card once the demo department is typed, so a visitor
 * can see the demo logins without them sitting inside the form itself.
 */
export default function DemoCredentialsCard({ departmentName = '' }) {
  const show = departmentName.trim().toLowerCase() === DEMO_DEPARTMENT;

  return (
    <Collapse in={show} orientation="vertical" unmountOnExit>
      <Card sx={{ width: { xs: '100%', md: 300 }, borderRadius: 2, opacity: 0.97 }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <InfoOutlined color="info" fontSize="small" />
            <Typography variant="subtitle1" fontWeight={600}>Demo-login</Typography>
          </Box>

          <Typography variant="overline" color="text.secondary">Medarbejder</Typography>
          <Line label="Navn" value={DEMO_USER.name} />
          <Line label="Adgangskode" value={DEMO_USER.password} />

          <Typography variant="overline" color="text.secondary" sx={{ mt: 1.5, display: 'block' }}>
            Infoskærm
          </Typography>
          <Line label="Navn" value={DEMO_INFOSCREEN.name} />
          <Line label="Kode" value={DEMO_INFOSCREEN.code} />

          <Typography variant="overline" color="text.secondary" sx={{ mt: 1.5, display: 'block' }}>
            Scanner (telefon)
          </Typography>
          <Line label="Navn" value={DEMO_SCANNER.name} />
          <Line label="Kode" value={DEMO_SCANNER.code} />
          <Line label="PIN (personale)" value={DEMO_STAFF_PIN} />
        </CardContent>
      </Card>
    </Collapse>
  );
}
